import { lazyLoad } from 'utils/loadable';

export const AddGuaranteeProgramPage = lazyLoad(
  () => import('./index'),
  module => module.AddGuaranteeProgramPage,
);
